module.exports = __webpack_public_path__ + "img/dashboard-res.f39e4ddb.jpg";